<template>
  <div
    id="article-setting"
    class="article-setting d-flex align-items-center justify-content-center"
    @click.self="isShow(false)"
  >
    <div class="setting-box d-flex flex-column">
      <div class="setting-head">
        <div class="media">
          <div class="media-body">
            <div class="h2">
              {{
                $t(`feature.article.setting.${createWithTab}`) ||
                $t("feature.article.content_setting")
              }}
            </div>
          </div>
          <div class="ms-3">
            <button
              v-show="tabActive === 'album'"
              v-if="canEdit"
              class="btn sc-btn sc-btn-outline"
              @click="openInputDialog"
            >
              เพิ่มรูปภาพ
            </button>
            <input
              ref="album"
              type="file"
              accept="image/jpg, image/png, image/jpeg"
              class="input-file hidden"
              @change="albumChange($event.target.files)"
            />
          </div>
          <div v-if="canEdit" class="ms-3">
            <button class="btn sc-btn sc-btn-opaque" @click="saveSetting">
              {{ $t("button.save") }}
            </button>
          </div>
        </div>
        <!-- <div class="sub-title">
          {{$t('feature.article.setting.sub_title')}}
        </div> -->
        <!-- <ul class="nav tabs hidden">
          <li role="presentation" :class="{ active: tabActive === 'projects' }" @click="setTab('projects')" class="tab">
            {{$t('feature.article.setting.project')}}
          </li>
          <li role="presentation" :class="{ active: tabActive === 'album' }" @click="setTab('album')" class="tab">
            {{$t('feature.article.setting.album')}}
          </li>
          <li role="presentation" :class="{ active: tabActive === 'map' }" @click="setTab('map')" class="tab">
            {{$t('feature.article.setting.map')}}
          </li>
          <li role="presentation" :class="{ active: tabActive === 'file' }" @click="setTab('file')" class="tab">
            {{$t('feature.article.setting.file')}}
          </li>
        </ul> -->
      </div>
      <div v-show="tabActive === 'projects'" class="setting-body col row mx-0">
        <div class="col-8 d-flex flex-column">
          <div class="input-group mb-2">
            <span id="basic-addon1" class="input-group-text">
              <i class="fas fa-search"></i>
            </span>
            <input
              v-model="searchProject"
              :placeholder="$t('feature.article.setting.project_search')"
              type="text"
              class="form-control"
              @keyup.enter="getProjects()"
            />
          </div>
          <div class="projects col">
            <div class="all pointer" @click="selectProjectAll()">
              {{ $t("label.select_all") }}
            </div>
            <div
              v-for="project in projects"
              :key="project.projectId"
              class="project"
              @click="selectProject(project)"
            >
              {{ project.projectName }}
            </div>
          </div>
          <div class="setting-owner">
            <p>ต้องการส่งข่าวนี้ถึง</p>
            <label class="select-input"
              >เจ้าของ
              <input
                v-model="localDataSetting.owner"
                type="checkbox"
                value="owner"
              />
              <span class="checkmark checkbox"></span>
            </label>
            <label class="select-input"
              >ผู้อยู่อาศัย
              <input
                v-model="localDataSetting.owner"
                type="checkbox"
                value="resident"
              />
              <span class="checkmark checkbox"></span>
            </label>
            <label class="select-input"
              >ผู้เช่า
              <input
                v-model="localDataSetting.owner"
                type="checkbox"
                value="renter"
              />
              <span class="checkmark checkbox"></span>
            </label>
            <label class="select-input"
              >ผู้ทำสัญญา
              <input
                v-model="localDataSetting.owner"
                type="checkbox"
                value="contract"
              />
              <span class="checkmark checkbox"></span>
            </label>
            <label class="select-input"
              >ผู้จอง
              <input
                v-model="localDataSetting.owner"
                type="checkbox"
                value="booking"
              />
              <span class="checkmark checkbox"></span>
            </label>
            <label class="select-input"
              >คนทั่วไป
              <input
                v-model="localDataSetting.owner"
                type="checkbox"
                value="visitor"
              />
              <span class="checkmark checkbox"></span>
            </label>
          </div>
        </div>
        <div class="col-4 d-flex flex-column">
          <div class="media project-head">
            <div class="media-body">
              โครงการที่เลือก ({{ localDataSetting.selectProjects.length }})
            </div>
            <div class="ms-3 pointer" @click="removeProjectAll()">
              ลบทั้งหมด
            </div>
          </div>
          <div class="project-select col px-0">
            <div
              v-for="(
                selectedProject, index
              ) in localDataSetting.selectProjects"
              :key="selectedProject.projectId"
              class="media tag"
            >
              <div class="media-body">
                {{ selectedProject.projectName }}
              </div>
              <div class="ms-3" @click="removeProject(index)">x</div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="tabActive === 'album'" class="setting-body">
        <div id="setting-album" class="col-12 row mx-0">
          <div
            v-for="(photo, index) in localDataSetting.album"
            :key="photo.name"
            class="position-relative photo added"
          >
            <span
              v-if="canEdit"
              class="position-absolute album-remove pointer"
              @click="removeAlbum(index)"
              >&times;</span
            >
            <img :src="photo.url" alt="" class="photo" />
          </div>
          <div v-if="localDataSetting.album.length === 0" class="empty-state">
            ไม่พบรูปภาพในอัลบั้ม
          </div>
        </div>
        <div class="remake">
          {{
            `* ${$t("feature.upload.condition_label")} ${labels.maxFileSize} MB`
          }}
        </div>
      </div>
      <div v-show="tabActive === 'map'" class="setting-body">
        <div id="setting-map" class="col-12 d-flex flex-column p-0">
          <div class="mb-3">
            <div v-if="canEdit" class="input-group">
              <span id="basic-addon1" class="input-group-text">
                <i class="fas fa-search"></i>
              </span>
              <gmap-autocomplete
                v-model="searchMap"
                class="form-control"
                placeholder="ระบุสถานที่ หรือตำแหน่งที่คุณต้องการ"
                @place_changed="setPlace"
              ></gmap-autocomplete>
              <span
                id="clear-map"
                class="input-group-text"
                @click="removeMarker"
              >
                <i class="fas fa-times-circle"></i>
              </span>
            </div>
            <div v-else>
              {{ searchMap || "ไม่ระบุ" }}
            </div>
          </div>
          <Gmap-Map
            :zoom="13"
            :center="center"
            style="width: 100%; height: 400px"
            @click="clickedMap"
          >
            <GmapMarker
              v-if="marker"
              :position="marker"
              @click="removeMarker()"
            />
          </Gmap-Map>
        </div>
      </div>
      <div v-show="tabActive === 'file'" id="setting-file" class="setting-body">
        <div
          v-if="!canEdit && !localDataSetting.file.name"
          class="upload-box col d-flex flex-column align-items-center justify-content-center"
        >
          ไม่พบไฟล์แนบ
        </div>
        <div
          v-else
          class="upload-box col d-flex flex-column align-items-center justify-content-center"
        >
          <input
            type="file"
            accept="application/pdf"
            class="input-file file"
            @change="fileChange($event.target.files)"
          />
          <span v-if="!localDataSetting.file.name">
            <img
              :src="'/static/icons/add-file.svg'"
              class="mb-3"
              width="26"
              height="26"
            />
          </span>
          <span v-if="!localDataSetting.file.name"> เพิ่มไฟล์ PDF ที่นี่ </span>
          <span v-if="localDataSetting.file.name">
            <img
              :src="'/static/icons/correct-circle.svg'"
              class="mb-3"
              width="26"
              height="26"
            />
          </span>
          <span v-if="localDataSetting.file.name">
            {{ localDataSetting.file.name }}
          </span>
        </div>
        <div class="remake">
          {{
            `* ${$t("feature.upload.condition_label")} ${labels.maxFileSize} MB`
          }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios"
import { UPLOAD } from "@/config/constant"
import { getCookie, Auth } from "@/lib/cookie"

export default {
  name: "ArticleSetting",
  props: {
    dataSetting: {
      type: null,
      default: undefined,
    },
    approvedAt: {
      type: null,
      default: undefined,
    },
    createWithTab: {
      type: null,
      default: undefined,
    },
    canEdit: {
      type: null,
      default: undefined,
    },
  },
  data() {
    const localDataSetting = JSON.parse(JSON.stringify(this.dataSetting))

    return {
      localDataSetting,
      tabActive: this.createWithTab || "projects",
      projects: [],
      searchMap: localDataSetting.map.locationName
        ? localDataSetting.map.locationName
        : "",
      searchProject: "",
      selectProjects: [],
      homeType: 1,
      projectType: 1,
      center: this.getDefaultLocation(localDataSetting),
      marker: {
        lat: localDataSetting.map.lat,
        lng: localDataSetting.map.lng,
      },
      labels: {
        maxFileSize: UPLOAD.MAX_FILE_SIZE_MB,
      },
      pendingUploads: [],
    }
  },
  beforeMount() {
    this.getProjects()
  },
  methods: {
    isShow() {
      this.$emit("isshow", false)
    },
    setTab(tab) {
      this.tabActive = tab
    },
    getProjects() {
      const vm = this

      axios
        .get(`${process.env.HOST}/api/admin/projects`, {
          params: { searchText: vm.searchProject },
          headers: {
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`,
          },
        })
        .then((res) => {
          vm.projects = res.data
        })
    },
    selectProjectAll() {
      this.localDataSetting.selectProjects = this.projects
      this.$emit("setEdit")
    },
    removeProjectAll() {
      this.localDataSetting.selectProjects = []
      this.$emit("setEdit")
    },
    selectProject(project) {
      if (!this.checkProjectDupicate(project)) {
        this.localDataSetting.selectProjects =
          this.localDataSetting.selectProjects.concat(project)
        this.$emit("setEdit")
      }
    },
    removeProject(index) {
      this.localDataSetting.selectProjects.splice(index, 1)
      this.$emit("setEdit")
    },
    checkProjectDupicate(project) {
      return this.localDataSetting.selectProjects.some((pro) => {
        if (pro.projectId === project.projectId) {
          return true
        }

        return false
      })
    },
    albumChange(file) {
      if (file[0].size / 1024 / 1024 > UPLOAD.MAX_FILE_SIZE_MB) {
        this.$message.error(
          `${this.$t("feature.upload.exceed_max_file_size")} ${
            UPLOAD.MAX_FILE_SIZE_MB
          } MB`,
        )

        return false
      }

      const reader = new FileReader()
      const vm = this
      let url = ""

      reader.onload = (e) => {
        url = e.target.result
      }

      reader.readAsDataURL(file[0])

      // upload album
      this.pendingUploads.push(
        axios
          .get(`${process.env.HOST}/api/uploads/image`, {
            params: {
              imageType: file[0].type,
              imageName: `articlealbum${Date.now()}`,
              featureName: "article",
            },
          })
          .then((res) => {
            vm.localDataSetting.album.push({
              url,
              name: file[0].name,
              image: file[0],
              key: res.data.imageKey,
            })
            return axios.put(res.data.url, file[0], {
              headers: { "content-type": file[0].type },
            })
          })
          .catch(() => {
            vm.$message.error(vm.$t("feature.upload.upload_failed"))
          }),
      )

      this.$emit("setEdit")

      return true
    },
    removeAlbum(index) {
      this.localDataSetting.album.splice(index, 1)

      this.$emit("setEdit")
    },
    fileChange(file) {
      if (file[0].size / 1024 / 1024 > UPLOAD.MAX_FILE_SIZE_MB) {
        this.$message.error(
          `${this.$t("feature.upload.exceed_max_file_size")} ${
            UPLOAD.MAX_FILE_SIZE_MB
          } MB`,
        )

        return false
      }

      const reader = new FileReader()
      const vm = this
      let url = ""

      reader.onload = (e) => {
        url = e.target.result
      }

      reader.readAsDataURL(file[0])

      // upload file
      this.pendingUploads.push(
        axios
          .get(`${process.env.HOST}/api/uploads/file`, {
            params: {
              contentType: file[0].type,
              fileName: `articlefile${Date.now()}`,
              feature: "article",
            },
          })
          .then((res) => {
            vm.localDataSetting.file = {
              url,
              name: file[0].name,
              file: file[0],
              fileKey: res.data.fileKey,
            }

            return axios.put(res.data.url, file[0], {
              headers: { "content-type": file[0].type },
            })
          })
          .catch(() => {
            vm.$message.error(vm.$t("feature.upload.upload_failed"))
          }),
      )

      this.$emit("setEdit")

      return true
    },
    // NOTE: uploads land on localDataSetting asynchronously; saving before
    // they settle would emit a clone without them (RJ-1691).
    async saveSetting() {
      await Promise.all(this.pendingUploads)
      this.$emit("save", this.localDataSetting)
      this.isShow()
    },
    clickedMap(e) {
      if (this.canEdit) {
        this.marker = e.latLng
        this.getLocationName(e.latLng.lat(), e.latLng.lng())

        this.$emit("setEdit")
      }
    },
    getLocationName(lat, lng) {
      /* global google */
      const geocoder = new google.maps.Geocoder()
      const vm = this

      geocoder.geocode({ location: this.marker }, (results, status) => {
        if (status === "OK") {
          vm.localDataSetting.map.locationName = results[0].formatted_address
          vm.searchMap = results[0].formatted_address
          vm.localDataSetting.map.lat = lat
          vm.localDataSetting.map.lng = lng
        }
      })
    },
    setPlace(place) {
      this.marker = place.geometry.location
      this.center = place.geometry.location
      this.localDataSetting.map.locationName = place.name
      this.localDataSetting.map.lat = place.geometry.location.lat()
      this.localDataSetting.map.lng = place.geometry.location.lng()
    },
    removeMarker() {
      this.marker = null
      this.searchMap = ""
      this.localDataSetting.map.locationName = null
      this.localDataSetting.map.lat = null
      this.localDataSetting.map.lng = null

      this.$emit("setEdit")
    },
    getDefaultLocation(setting = this.localDataSetting) {
      if (setting.map.lat && setting.map.lng) {
        return {
          lat: Number.parseFloat(setting.map.lat),
          lng: Number.parseFloat(setting.map.lng),
        }
      }

      return { lat: 13.8232912, lng: 100.55719 }
    },
    openInputDialog() {
      this.$refs.album.click()
    },
  },
}
</script>

<style lang="scss" scoped>
#article-setting {
  background-color: rgba(74, 74, 74, 0.5);
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 10;
  top: 0;
  left: 0;
}
.setting-box {
  position: absolute;
  border-radius: 15px;
  background-color: $white;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.2);
  width: auto;
  height: auto;
  max-width: 800px;
  max-height: 600px;
}
.setting-head {
  padding-top: 20px;
  padding-left: 25px;
  padding-right: 25px;
}
.setting-body {
  padding: 20px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}
.h2 {
  font-size: 24px;
  font-weight: bold;
  line-height: 1.7;
  letter-spacing: -0.1px;
  margin-top: 0;
  color: $black;
}
.sub-title {
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4a4a4a;
  margin-bottom: 15px;
}
.tab {
  margin-right: 30px;

  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
}
.input-group {
  border: 1px solid #e0e0e0;
  border-radius: 10em;
}
.input-group-addon {
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;
  background-color: $white;
}
.form-control {
  height: 32px;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  background-color: $white;
  border: none;
}
.dropdown {
  padding-right: 5px;
}
.projects {
  background-color: $white;
  height: calc(100% - 150px);
  margin-bottom: 15px;
  padding: 10px;
  overflow-y: auto;

  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: -0.1px;
  text-align: left;
  color: #4a4a4a;
}
.projects .project-head {
  cursor: pointer;
  border-bottom: 1px solid #e0e0e0;
}
.project-head {
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #9b9b9b;
}
.project {
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: -0.1px;
  text-align: left;
  color: #4a4a4a;
}
.projects > .all {
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: $blue;
}
.label {
  padding: 1px 8px;
  margin: 5px;
  border-radius: 1em;
}
.input-group-text {
  background: none;
  border: none;
  border-radius: 25px;
  background-color: $white;
}
.tag {
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: -0.1px;
  text-align: left;
  color: $white;
  background-color: $green;
  padding: 3px 9px;
  border-radius: 15px;
  margin: 5px;
}
.project-select {
  overflow-y: auto;
}
.photo {
  width: 148px;
  height: 148px;
  border-radius: 16px;
  border: 2px dashed #e0e0e0;
  object-fit: cover;

  &.added {
    border: 1px solid #e0e0e0;
  }
}
div.photo {
  margin-right: 15px;
  margin-bottom: 15px;

  font-size: 14px;
  font-weight: 500;
  text-align: center;
  color: #9b9b9b;
}
img.photo {
  width: 146px;
  height: 146px;
  border: none;
}
.input-file {
  opacity: 0;
  position: absolute;
  cursor: pointer;
}
.input-file.file {
  z-index: 9;
  width: 100%;
  height: 100%;
}
.input-file.album {
  width: 148px;
  height: 148px;
}
.input-file.hidden {
  width: 0;
  height: 0;
  position: absolute;
}
.album-remove {
  top: 5px;
  right: 5px;
  background: #aaa;
  border-radius: 50%;
  border: 2px solid $white;
  width: 20px;
  height: 20px;
  padding: 3px;

  font-size: 16px;
  color: $white;
  line-height: 0.5;
}
#setting-album {
  overflow-y: auto;
  width: 520px;
  max-height: 360px;
}
#setting-file {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.18;
  text-align: center;
  color: #8c8786;
}
.upload-box {
  width: 375px;
  height: 220px;
  border: 2px dashed #e0e0e0;
  border-radius: 15px;
  margin: 0 auto;
}
.remake {
  font-size: 11px;
  font-weight: normal;
  line-height: 1.64;
  letter-spacing: -0.1px;
  color: #8c8786;
  margin-top: 16px;
  text-align: center;
}
.empty-state {
  color: #8c8786;
  text-align: center;
  margin: 0 auto;
  padding: 40px;
}
#setting-map {
  width: 660px;
}
#clear-map {
  opacity: 0.6;
  transition: opacity 1s ease;

  &:hover {
    opacity: 1;
  }
}
</style>
